export const sortDirections = {
  asc: 'asc',
  desc: 'desc',
};
